import { makeCRMApi } from 'services/CrmApi/CrmApi';
import { isTrackedUser } from './context';
import { ITrackingEventInput } from './types';

const FLUSH_SIZE = 20;
const FLUSH_INTERVAL_MS = 5000;
const MAX_BUFFER = 200;

let buffer: ITrackingEventInput[] = [];

let timer: ReturnType<typeof setTimeout> | null = null;

const send = (events: ITrackingEventInput[], useKeepalive: boolean): void => {
  if (!isTrackedUser()) return;

  makeCRMApi().postTrackingEvents(events, { keepalive: useKeepalive });
};

export const flush = (useKeepalive = false): void => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  if (buffer.length === 0) return;
  const batch = buffer;
  buffer = [];
  send(batch, useKeepalive);
};

export const enqueue = (event: ITrackingEventInput): void => {
  if (!isTrackedUser()) return;

  if (buffer.length >= MAX_BUFFER) {
    // protect memory if backend is unreachable
    buffer.shift();
  }
  buffer.push(event);

  if (buffer.length >= FLUSH_SIZE) {
    flush();
    return;
  }
  if (!timer) {
    timer = setTimeout(() => flush(), FLUSH_INTERVAL_MS);
  }
};

export const installLifecycleHandlers = (): void => {
  // flush on tab hide / unload using keepalive so the request survives
  const onHide = () => flush(true);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') onHide();
  });
  window.addEventListener('pagehide', onHide);
};
